import { createApp } from 'vue';
import App from './App.vue';
import router from "@/router";

import "@/assets/style/app.scss";


import "lib-flexible";

createApp(App)
.use(router)
.mount('#app');
